import { render } from "./pl35-baij.vue?vue&type=template&id=8acb541c&scoped=true"
import script from "./pl35-baij.vue?vue&type=script&lang=js"
export * from "./pl35-baij.vue?vue&type=script&lang=js"

import "./pl35-baij.vue?vue&type=style&index=0&id=8acb541c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8acb541c"]])

export default __exports__